// ページ内リンクスクロール
// document.addEventListener('click', e => {
//   const target = e.target.closest('a[href^="#"]');
//   if (!target) return;
//   e.preventDefault();
//   const targetId = target.hash;
//   const targetElement = document.querySelector(targetId);
//   if (targetElement) {
//     const headerHeight = document.querySelector('header')?.offsetHeight || 0;
//     const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
//     window.scrollTo({
//       top: targetPosition - headerHeight,
//       behavior: 'smooth'
//     });
//     history.pushState(null, null, targetId);
//   }
// });


// ドロワー最近チェックした商品
  (function () {
    const storageKey = 'recentlyViewedProduct';

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getRecentlyViewedProducts() {
      try {
        const storedData = localStorage.getItem(storageKey);
        const products = storedData ? JSON.parse(storedData) : [];
        return Array.isArray(products) ? products : [];
      } catch (error) {
        return [];
      }
    }

    function renderRecentlyViewedMenuDrawer() {
      const containers = document.querySelectorAll('[data-recently-viewed-menu-drawer]');
      if (!containers.length) return;

      const products = getRecentlyViewedProducts();

      containers.forEach(function (container) {
        const limit = Number(container.dataset.limit || 6);
        const displayProducts = products.slice(0, limit);

        if (!displayProducts.length) {
          container.innerHTML = '';
          container.closest('.menu-drawer__recently-viewed')?.classList.add('is-empty');
          return;
        }

        container.closest('.menu-drawer__recently-viewed')?.classList.remove('is-empty');

        const html = displayProducts.map(function (item) {
          const title = escapeHtml(item.productTitle);
          const url = escapeHtml(item.productUrl);
          const img = escapeHtml(item.productImgSmall || item.productImg);
          const alt = escapeHtml(item.productImageAltText || item.productTitle);

          if (!url || !img) return '';

          return `
            <a
              href="${url}"
              class="menu-drawer__recently-viewed-card"
              aria-label="${title}"
            >
              <img
                src="${img}"
                alt="${alt}"
                width="120"
                height="120"
                loading="lazy"
                decoding="async"
                class="menu-drawer__recently-viewed-img"
              >
            </a>
          `;
        }).join('');

        container.innerHTML = html;
      });
    }

    document.addEventListener('DOMContentLoaded', renderRecentlyViewedMenuDrawer);

    // Shopifyテーマエディタ上でセクション再読み込みされた場合にも対応
    document.addEventListener('shopify:section:load', renderRecentlyViewedMenuDrawer);

    // メニュードロワーを開いたタイミングでも再描画
    document.addEventListener('click', function (event) {
      const trigger = event.target.closest(
        'summary.header__icon--menu, .header__icon--menu, [data-drawer-open], [aria-controls="menu-drawer"]'
      );

      if (trigger) {
        window.setTimeout(renderRecentlyViewedMenuDrawer, 50);
      }
    });
  })();


  document.addEventListener('DOMContentLoaded', function () {
    function replaceJudgeMeText() {
      document.querySelectorAll('.jm-text').forEach(function (el) {
        el.childNodes.forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent.replace('役立つ？', '参考になりましたか？');
            node.textContent = node.textContent.replace('Helpful?', '参考になりましたか？');
          }
        });
      });
    }

    replaceJudgeMeText();

    var observer = new MutationObserver(function () {
      replaceJudgeMeText();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });


document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("a[href]");
  const currentDomain = location.origin;

  links.forEach(link => {
    const href = link.getAttribute("href");
    if (link.target === "_blank") return;
    if (
      href.startsWith("#") ||
      href.startsWith("/") ||
      href.startsWith(".") ||
      href.startsWith(currentDomain)
    ) {
      return;
    }
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noreferrer noopener");
  });
});